<div *ngIf="open" class="fixed inset-0 flex items-center justify-center p-4" style="z-index: var(--z-dialog)" aria-hidden="false">
  <div class="absolute inset-0 bg-gray-900/50 backdrop-blur-sm" aria-hidden="true" (click)="onBackdropClick()"></div>
  <div
    #dialog
    class="relative max-h-[calc(100vh-2rem)] overflow-y-auto bg-white rounded-xl shadow-xl w-full"
    [ngClass]="maxWidthClass"
    role="dialog"
    aria-modal="true"
    aria-labelledby="modal-title"
    tabindex="-1">
    <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
      <h3 id="modal-title" class="text-lg font-semibold text-gray-800">{{ title }}</h3>
      <button
        type="button"
        (click)="close.emit()"
        class="p-1.5 rounded-lg text-gray-400 hover:text-gray-600 hover:bg-gray-100 transition-colors"
        aria-label="Close">
        <lucide-icon name="X" [size]="18"></lucide-icon>
      </button>
    </div>
    <div class="p-6">
      <ng-content></ng-content>
    </div>
    <ng-content select="[modal-footer]"></ng-content>
  </div>
</div>
